export interface PresetTemplate {
  id: string
  name: string
  content: string
  type: 'VERIFICATION' | 'NOTIFICATION' | 'MARKETING'
  description: string
}

export const presetTemplates: Record<string, PresetTemplate[]> = {
  VERIFICATION: [
    {
      id: 'verification-1',
      name: '标准验证码模板',
      content: '您的验证码是：${code}，请在5分钟内完成验证。',
      type: 'VERIFICATION',
      description: '适用于用户注册、登录等场景的纯模板内容'
    },
    {
      id: 'verification-2',
      name: '安全验证码模板',
      content: '您的安全验证码是：${code}，有效期5分钟，请勿泄露给他人。',
      type: 'VERIFICATION',
      description: '适用于敏感操作的二次验证的纯模板内容'
    },
    {
      id: 'verification-3',
      name: '简单验证码模板',
      content: '验证码：${code}，5分钟内有效。',
      type: 'VERIFICATION',
      description: '简洁的验证码模板的纯模板内容'
    }
  ],
  NOTIFICATION: [
    {
      id: 'notification-1',
      name: '订单确认通知',
      content: '您的订单${orderNo}已确认，预计${time}送达，感谢您的购买！',
      type: 'NOTIFICATION',
      description: '适用于电商订单确认'
    },
    {
      id: 'notification-2',
      name: '发货通知',
      content: '您的商品${product}已发货，快递单号：${trackingNo}，预计${time}送达。',
      type: 'NOTIFICATION',
      description: '适用于商品发货通知'
    },
    {
      id: 'notification-3',
      name: '系统通知',
      content: '系统维护通知：${message}，预计${time}完成，给您带来不便敬请谅解。',
      type: 'NOTIFICATION',
      description: '适用于系统维护等通知'
    }
  ],
  MARKETING: [
    {
      id: 'marketing-1',
      name: '促销活动通知',
      content: '限时优惠！${product}仅需${price}元，${time}前有效，点击立即购买！',
      type: 'MARKETING',
      description: '适用于促销活动推广'
    },
    {
      id: 'marketing-2',
      name: '新品发布通知',
      content: '新品${product}现已上市，首发价${price}元，${time}前享受优惠！',
      type: 'MARKETING',
      description: '适用于新品发布推广'
    },
    {
      id: 'marketing-3',
      name: '会员专享通知',
      content: '尊敬的${memberLevel}会员，专享${discount}折优惠，${time}前有效！',
      type: 'MARKETING',
      description: '适用于会员专享活动'
    }
  ]
}

// 变量提取函数
export const extractVariables = (content: string): string[] => {
  const patterns = [
    /\$\{(\w+)\}/g,  // ${variable}
    /\{(\w+)\}/g,    // {variable}
  ]
  
  const variables = new Set<string>()
  
  patterns.forEach(pattern => {
    let match
    while ((match = pattern.exec(content)) !== null) {
      variables.add(match[1])
    }
  })
  
  return Array.from(variables)
}

// 变量验证函数
export const validateVariables = (variables: string[], type: string): string[] => {
  const errors: string[] = []
  
  if (type === 'VERIFICATION' && variables.length > 1) {
    errors.push('验证码模板仅支持1个变量')
  }
  
  if (variables.length > 5) {
    errors.push('模板变量不能超过5个')
  }
  
  return errors
}
